import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from "@angular/router";
import * as jsPDF from 'jspdf';

import { SharedService } from "./../../../shared/shared.service";
import { AdminPrasadOrderService } from './../../services/admin-prasad-order.service';
import { PujaPrasadService } from "./../../../prasad-order/puja-prasad.service";
import { PagingGridData } from "./../../models/paging-grid-data";
import { PujaPrasadMaster } from './../../../prasad-order/puja-prasad-master';
import { AdminMobileappService } from '../../services/admin-mobileapp.service';
import { DevoteeDetail } from '../../../Devotee/devotee-detail';
import { PrasadOrderView } from '../../../prasad-order/prasad-order';

@Component({
  selector: 'app-prasad-order-list',
  templateUrl: './prasad-order-list.component.html',
  styleUrls: ['./prasad-order-list.component.css'],
  providers: [AdminPrasadOrderService, PujaPrasadService, AdminMobileappService]
})
export class PrasadOrderListComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private activeRoute: ActivatedRoute,
    private sharedService: SharedService,
    private adminPrasadOrderService: AdminPrasadOrderService,
    private pujaPrasadService: PujaPrasadService,
    private adminMobileAppService: AdminMobileappService) { }

  devoteeList: DevoteeDetail[] = [];
  pagingGridData: PagingGridData;
  printPOData: any[] = [];
  errorMessage: string = "";
  successMessage: string = "";
  searchForm: FormGroup;
  selOrderVidhiIdArray: number[] = [];
  selMobileOrderArray: number[] = [];
  addressView: boolean = false;
  showAddPrintBtn: boolean = false;
  pujaPrasadList: PujaPrasadMaster[] = [];

  ngOnInit() {
    this.createSearchForm();

    this.activeRoute.params.subscribe(params => {
      if (params.mobileNo) {
        this.searchForm.controls.MobileNo.setValue(params.mobileNo);
      }
    })

    this.loadPujaPrasadList();
    this.searchForm.controls.PrasadOrderStartDate.setValue('2019-09-01');

    if (this.searchForm.controls.MobileNo.value) {
      this.prasadOrderSearch();
      return;
    }


    if (localStorage.getItem)
      var oldSearchFormValue = (JSON.parse(localStorage.getItem("PrasadOrderSearchForm")));

    console.log(oldSearchFormValue);

    if (oldSearchFormValue != null) {
      this.searchForm.setValue(oldSearchFormValue);
      this.prasadOrderSearch();
    }


  }

  private loadPujaPrasadList(): void {
    this.sharedService.showSpinner();
    this.pujaPrasadService.getPujaDetails().subscribe(
      data => {
        this.pujaPrasadList = data;
        //this.prasadOrderSearch();
      },
      err => {
        console.log(err);
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  getPujaPrasadType(pujaPrasadId: number) {

    if (pujaPrasadId == 0)
      return "";

    return this.pujaPrasadList.find(x => x.Id == pujaPrasadId).TypeOfPuja;
  }


  prasadOrderSearch() {
    this.pageChanged(1);
  }

  resetSearch() {
    this.searchForm.reset();
    this.searchForm.controls.PrasadOrderStartDate.setValue('2019-09-01');

    this.pageChanged(1);
  }


  pageChanged(pageNo: number) {
    this.errorMessage = "";
    let searchGridEntity = this.searchForm.value;

    // Validate Amount Field
    if (searchGridEntity.PriceFrom != null && searchGridEntity.PriceTo == null) {
      searchGridEntity.PriceTo = searchGridEntity.PriceFrom;
    }
    else if (searchGridEntity.PriceFrom == null && searchGridEntity.PriceTo != null) {
      this.errorMessage = "Amount range is not proper."
      return;
    }
    else if (searchGridEntity.PriceFrom > searchGridEntity.PriceTo) {
      this.errorMessage = "Amount range is not proper."
      return;
    }

    localStorage.setItem("PrasadOrderSearchForm", JSON.stringify(this.searchForm.value));


    searchGridEntity.PageNo = pageNo;

    searchGridEntity.OrderBookedBy = searchGridEntity.OrderBy;


    this.sharedService.showSpinner();
    this.adminPrasadOrderService.search(searchGridEntity).subscribe(
      data => {
        console.log(data);
        this.pagingGridData = data.PrasadOrderVidhis;
        this.showAddPrintBtn = true;
        this.selOrderVidhiIdArray = [];
        this.selMobileOrderArray = [];
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }


  checkBoxClick(prasadOrder: any) {

    console.log(this.selOrderVidhiIdArray.indexOf(prasadOrder.PrasadOrderPujaVidhiId));

    if (this.selOrderVidhiIdArray.find(x => x == prasadOrder.PrasadOrderPujaVidhiId)) {
      this.selOrderVidhiIdArray.splice(this.selOrderVidhiIdArray.indexOf(prasadOrder.PrasadOrderPujaVidhiId), 1);
    }
    else {
      this.selOrderVidhiIdArray.push(prasadOrder.PrasadOrderPujaVidhiId);
    }

    console.log(this.selOrderVidhiIdArray);
  }

  paymentDone() {
    if (this.selOrderVidhiIdArray.length <= 0) {
      return;
    }

    let orderIds = this.pagingGridData.PageData.filter(x => this.selOrderVidhiIdArray.indexOf(x.PrasadOrderPujaVidhiId) >= 0).map(x => x.OrderId);


    this.sharedService.showSpinner();
    this.adminPrasadOrderService.paymentDone(orderIds).subscribe(
      data => {
        console.log(data);
        this.successMessage = "Payment Status Update Successfully.";
        this.pageChanged(1);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )

  }

  dispatchPrasad() {
    if (this.selOrderVidhiIdArray.length <= 0) {
      return;
    }

    let orderIds = this.pagingGridData.PageData.filter(x => this.selOrderVidhiIdArray.indexOf(x.PrasadOrderPujaVidhiId) >= 0).map(x => x.OrderId);


    this.sharedService.showSpinner();
    this.adminPrasadOrderService.prasadDispatch(orderIds).subscribe(
      data => {
        console.log(data);
        this.successMessage = data;
        this.pageChanged(1);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )

  }

  sendDispatchSMS() {
    this.errorMessage = "";
    let searchGridEntity = this.searchForm.value;

    // Validate Amount Field
    if (searchGridEntity.PriceFrom != null && searchGridEntity.PriceTo == null) {
      searchGridEntity.PriceTo = searchGridEntity.PriceFrom;
    }
    else if (searchGridEntity.PriceFrom == null && searchGridEntity.PriceTo != null) {
      this.errorMessage = "Amount range is not proper."
      return;
    }
    else if (searchGridEntity.PriceFrom > searchGridEntity.PriceTo) {
      this.errorMessage = "Amount range is not proper."
      return;
    }

    if (!confirm("Do you want to send Dispach SMS to filter Prasad Orders")) {
      return;
    }

    searchGridEntity.PageNo = 0;

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.prasadDispatchSendSMS(searchGridEntity).subscribe(
      data => {
        console.log(data);
        this.successMessage = data;
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )

  }

  deleteOrder(orderId: number) {

    if (!confirm("Do you want to delete prasad order ?")) {
      return;
    }

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.deleteOrder(orderId).subscribe(
      data => {
        console.log(data);
        this.successMessage = "Order deleted successfully.";
        this.pageChanged(1);
      },
      err => {
        // check err.body is String type
        if (typeof err.body === 'string') {
          this.errorMessage = err.body;
        } else {
          this.errorMessage = "Something went wrong. Please try again later.";
        }
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }




  createSearchForm(): void {
    this.searchForm = this.formBuilder.group({
      MobileNo: [""],
      PriceFrom: [],
      PriceTo: [],
      PujaDateFrom: [],
      PujaDateTo: [],
      PaymentMode: [],
      POStatus: [],
      OrderBy: [],
      FirstName: [""],
      MiddleName: [""],
      LastName: [""],
      City: [],
      State: [],
      PujaVidhiId: [],
      PrasadOrderStartDate: [],
      PrasadOrderEndDate: [],
      HasDispatched: [false],
    });
  }

  changeAddressView(e) {
    this.addressView = e.target.checked;
    console.log("addressView " + e.target.checked);
  }

  addToPrintAddressByCheckBox() {

   // this.printPOData = [];
    var selectedData = this.pagingGridData.PageData.filter(x => this.selOrderVidhiIdArray.indexOf(x.PrasadOrderPujaVidhiId) >= 0);


    selectedData.forEach(element => {
      // const mobileCount = this.printPOData.filter(x => x.DevoteeDetail.MobileNo === element.DevoteeDetail.MobileNo);

      if (!this.printPOData.includes(element)) {
        this.printPOData.push(element);
      }
    });

    console.log(this.printPOData);
  }

  addAllToPrint() {

    this.pagingGridData.PageData.forEach(element => {
      // const mobileCount = this.printPOData.filter(x => x.DevoteeDetail.MobileNo === element.DevoteeDetail.MobileNo);
      if (!this.printPOData.includes(element)) {
        this.printPOData.push(element);
      }
    });

    console.log(this.printPOData);
  }

  addToPrintAddress() {
    this.errorMessage = "";
    let searchGridEntity = this.searchForm.value;

    // Validate Amount Field
    if (searchGridEntity.PriceFrom != null && searchGridEntity.PriceTo == null) {
      searchGridEntity.PriceTo = searchGridEntity.PriceFrom;
    }
    else if (searchGridEntity.PriceFrom == null && searchGridEntity.PriceTo != null) {
      this.errorMessage = "Amount range is not proper."
      return;
    }
    else if (searchGridEntity.PriceFrom > searchGridEntity.PriceTo) {
      this.errorMessage = "Amount range is not proper."
      return;
    }

    searchGridEntity.PageNo = 0;

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.search(searchGridEntity).subscribe(
      data => {

        data.Data.map(x => this.printPOData.push(x));
        this.showAddPrintBtn = false;
        console.log(this.printPOData);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  printAddressPage1(): void {
    var doc = new jsPDF()
    let printContents = document.getElementById('print-section').innerHTML;
    doc.addHTML(printContents)
    doc.save('a4.pdf')
  }


  printAddressPage(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=700,width=1000');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>        

          <style>
          
          body {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333;
    background-color: #fff;
    margin: 0;
}

address {
    margin-bottom: 20px;
    font-style: normal;
    line-height: 1.42857143;
}

* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}


.barcode { font-family: "Free 3 of 9";font-size: 32px }

.addressbox{
    padding-top: 5px;
    padding-left: 10px;  
    height: 1.55in; 
    overflow: hidden;
    /*color:#885f07;*/
}

.boxlabel{
        /* Avery 5160 labels -- CSS and HTML by MM at Boulder Information Services */
        width: 2.51in; /* plus .6 inches from padding */
        height: 2in; /*.875in; /* plus .125 inches from padding */
        padding: 2px .1in 0;
        margin-right: .125in; /* the gutter */
        margin-bottom: 10px;
        font-size: 13px;
        float: left;
        /*text-align: center;*/
        overflow: hidden;
        outline: 1px auto; /*outline doesn't occupy space like border does border-bottom: 1px dotted */
        outline-width: 1px;
        outline-style: inset;
        color: black;
      }
      
      .pagebody {
        width: 8.5in;            
        margin-left: 10px;
        }
      
    .page-break  {
        clear: left;
        display:block;
        page-break-after:always;
    }

    .boxlabel:nth-child(15n+1){
            margin-top: 50px;
        }
        .boxlabel:nth-child(15n+2) {
            margin-top: 50px;
        }
        .boxlabel:nth-child(15n+3){
            margin-top: 50px;
        }
          </style>         
       
        </head>
    <body>${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

}

//onload="window.print();window.close()"


// WEBPACK FOOTER //
// ./src/app/admin/components/prasad-order-list/prasad-order-list.component.ts